import { Button, UIHeading3, Theme } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './NewbuildingBrokerConsultantCarouselBanner.css';

interface INewbuildingBrokerConsultantCarouselBannerProps {
  url: string;
  onClick(): void;
}

export const NewbuildingBrokerConsultantCarouselBanner: React.FC<INewbuildingBrokerConsultantCarouselBannerProps> = ({
  url,
  onClick,
}) => {
  return (
    <a
      href={url}
      onClick={onClick}
      target="_blank"
      rel="noreferrer"
      className={styles['container']}
      data-testid="NewbuildingBrokerConsultantCarouselBanner"
    >
      <div className={styles['content']}>
        <div className={styles['title']}>
          <Theme theme="colored">
            <UIHeading3>
              Поможем найти и купить
              <br />
              квартиру под ваш
              <br />
              бюджет
            </UIHeading3>
          </Theme>
        </div>
        <Theme theme="colored">
          <Button size="M" fullWidth>
            О сервисе
          </Button>
        </Theme>
      </div>
    </a>
  );
};
